import React, { useEffect, useState } from "react";
import {
  Image,
  Alert,
  Slider,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
} from "react-native";
//import { Picker } from "@react-native-community/picker";
import { Entypo } from "@expo/vector-icons";
import { StackActions } from "@react-navigation/native";
import BackgroundAdmin from "../components/BackgroundAdmin";
import Title from "../components/Title";
import Logo from "../components/Logo";
import Calendario from "../components/Calendario";
import makeRequest from "../components/makeRequest";
import ButtonLayout from "../components/ButtonLayout";
import { Ionicons } from "@expo/vector-icons";
import call from "react-native-phone-call";
import dateformat from "dateformat";
export default function (props) {
  const [day, setDay] = useState(null);
  const [citas, setCitas] = useState([]);
  const [showCitas, setShowCitas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [aforo, setAforo] = useState(null);
  const [filter, setFilter] = useState("Todas");
  const [reload, setReload] = useState(false);
  const [closed, setClosed] = useState(true);
  useEffect(() => {
    switch (filter) {
      case "Pendientes":
        setShowCitas(
          citas.filter((e) => e.cancelada == false && e.aceptada == false)
        );
        break;
      case "Aceptadas":
        setShowCitas(citas.filter((e) => e.aceptada == true));
        break;
      case "Canceladas":
        setShowCitas(citas.filter((e) => e.cancelada == true));
        break;
      case "Todas":
        setShowCitas(citas);
        break;
    }
  }, [filter]);
  const tryClose = () => {
    Alert.alert(
      "¿Cerrar este día?",
      "Se cancelarán todas las citas.",
      [
        {
          text: "Aceptar",
          onPress: async () => {
            const response = await makeRequest(
              "citas/cerrar/" + day.toISOString(),
              "post"
            );
            if (response[0] == 200) getCitas(day);
          },
        },
        {
          text: "Cancelar",
          onPress: () => {
            console.log("Cancel Pressed");
          },
          style: "cancel",
        },
      ],
      { cancelable: false }
    );
  };
  const getCitas = (e) => {
    setDay(e);
    const getCitas = async (e) => {
      setLoading(true);
      const response = await makeRequest(
        "citas/" +
          (e.getFullYear() +
            "-" +
            (e.getMonth() < 10 ? "0" + e.getMonth() : e.getMonth()) +
            "-" +
            (e.getDate() < 10 ? "0" + e.getDate() : e.getDate())) +
          "/" +
          props.route.params.instalaciones._id,
        "get"
      );
      if (response[0] == 200) {
        setFilter("Todas");
        setCitas(response[1]);
        setShowCitas(response[1]);
      } else setCitas([]);
      setLoading(false);
    };
    getCitas(e);
  };
  useEffect(() => {
    const getAforo = async () => {
      const response = await makeRequest(
        "aforos/actual/" + props.route.params.instalaciones._id,
        "get"
      );
      if (response[0] == 200) setAforo(response[1]);
      else setAforo({});
    };
    getAforo();
  }, [reload]);
  return (
    <BackgroundAdmin scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View>
        <ButtonLayout
          text='Lector QR'
          onPress={() =>
            props.navigation.navigate("QrReader", {
              instalacion: props.route.params.instalaciones,
            })
          }
        />
        {aforo && (
          <Aforo
            reload={reload}
            setReload={setReload}
            instalacion={props.route.params.instalaciones._id}
            max={aforo.maximo}
            min={aforo.reservado}
            day={day}
            used={aforo.extra + aforo.reservado}
            fullMax={aforo.reservado}
          />
        )}
        <Title
          style={{ fontFamily: "Montserrat-Bold", margin: 5, fontSize: 16 }}>
          Calendario de citas
        </Title>
        {props.route.params ? (
          <Calendario
            maxDate={props.route.params.maxDate}
            minDate={props.route.params.minDate}
            onChange={(e) => getCitas(e)}></Calendario>
        ) : (
          <Calendario onChange={(e) => getCitas(e)}></Calendario>
        )}
        {!day && (
          <Title style={{ margin: 20, fontSize: 15 }}>
            Selecciona un día para realizar alguna modificación o mostrar citas
          </Title>
        )}
      </View>

      {loading && (
        <ActivityIndicator
          size='large'
          style={{ marginTop: 10 }}
          color='rgba(255,255,255, 0.9)'
        />
      )}
      {day && !loading && citas.length == 0 && (
        <Title
          style={{
            fontFamily: "Montserrat-Bold",
            margin: 50,
            fontSize: 16,
          }}>{`No hay citas guardadas para el ${dateformat(
          day,
          "dd/mm/yy"
        )}`}</Title>
      )}
      {citas.length > 0 && !loading && (
        <>
          <PorHoras
            setShowCitas={setShowCitas}
            setFilter={setFilter}
            filter={filter}
            citas={citas}
            dia={day}
            setClosed={setClosed}
            instalacion={props.route.params.instalaciones._id}
          />
          <View style={{ marginTop: 20, alignItems: "center" }}>
            <TouchableOpacity
              style={{
                height: 50,
                width: 300,
                maxWidth: "90%",
                backgroundColor: "white",
                borderRadius: 15,
                color: "#3E4672",
                textAlign: "center",
                fontFamily: "Montserrat-Bold",
                margin: 10,
              }}>
              <Picker
                style={{
                  height: 50,
                  width: 300,
                  color: "#3E4672",
                  textAlign: "center",
                  fontFamily: "Montserrat-Bold",
                }}
                selectedValue={filter}
                onValueChange={(value, index) => setFilter(value)}>
                <Picker.Item label='Pendientes' value='Pendientes' />
                <Picker.Item label='Todas' value='Todas' />
                <Picker.Item label='Aceptadas' value='Aceptadas' />
                <Picker.Item label='Canceladas' value='Canceladas' />
              </Picker>
            </TouchableOpacity>
            {showCitas.map((e) => (
              <Cita
                day={day}
                ninos={e.ninos}
                adultos={e.adultos}
                usuario={e.user.nombre + " " + e.user.apellido}
                telefono={e.user.telefono}
                cancelada={e.cancelada}
                key={e._id}
                id={e._id}
                fecha={new Date(e.inicio)}
                final={new Date(e.final)}
                getCitas={(dia) => getCitas(dia)}
              />
            ))}
          </View>
          {!closed && (
            <ButtonLayout text='Cerrar este día' onPress={tryClose} />
          )}
        </>
      )}
      <View style={{ height: 50 }}></View>
    </BackgroundAdmin>
  );
}

function PorHoras(props) {
  const [show, setShow] = useState(false);
  const [aforos, setAforos] = useState([]);
  const [hora, setHora] = useState({});
  const [aforo, setAforo] = useState({});
  useEffect(() => {
    const getAforosDia = async () => {
      console.log(props.instalacion);
      const response = await makeRequest(
        "aforos/admin/" + props.dia.toISOString() + "/" + props.instalacion,
        "get"
      );
      if (response[0] == 200 && response[1].length > 0) {
        setAforos(response[1]);
        setHora({
          minutos: new Date(response[1][0].fecha).getMinutes(),
          horas: new Date(response[1][0].fecha).getHours(),
        });
        setAforo(response[1][0]);
      }
    };
    getAforosDia();
  }, [props.dia]);
  const handleFilter = (value) => {
    setHora({
      minutos: new Date(aforos[value].fecha).getMinutes(),
      horas: new Date(aforos[value].fecha).getHours(),
    });
    setAforo(aforos[value]);
    if (props.setShowCitas) {
      props.setShowCitas(
        props.citas.filter((e) => e.aforo == aforos[value]._id)
      );
    }
  };
  return (
    <View>
      <ButtonLayout
        text='Filtrar por horas'
        style={{ marginBottom: 0 }}
        onPress={() => {
          setShow(!show);
          props.setShowCitas(props.citas);
          props.setFilter("Todas");
        }}></ButtonLayout>
      {show && aforos.length > 0 && (
        <View
          style={{
            backgroundColor: "rgba(255,255,255, 0.5)",
            padding: 5,
            width: 300,
            maxWidth: "90%",
            alignSelf: "center",
            marginTop: 10,
            borderRadius: 10,
          }}>
          {props.setClosed && props.setClosed(false)}
          <Title>
            {hora.horas < 10 ? "0" + hora.horas : hora.horas}:
            {hora.minutos < 10 ? "0" + hora.minutos : hora.minutos}
            {"\n"}Aforo reservado: {aforo.reservado}
          </Title>
          <Slider
            value={0}
            style={{ width: "100%", height: 30 }}
            minimumValue={0}
            maximumValue={aforos.length - 1}
            step={1}
            thumbTintColor='#3E4672'
            minimumTrackTintColor='#3E4672'
            onValueChange={handleFilter}
            disabled={aforos.length === 0}></Slider>
        </View>
      )}
      {show && aforos.length == 0 && (
        <View
          style={{
            backgroundColor: "rgba(255,255,255, 0.5)",
            padding: 5,
            width: 300,
            maxWidth: "90%",
            alignSelf: "center",
            marginTop: 10,
            borderRadius: 10,
          }}>
          {props.setClosed && props.setClosed(true)}
          <Title>Cierra este día</Title>
        </View>
      )}
    </View>
  );
}

function Aforo(props) {
  const [used, setUsed] = useState(props.used);
  const [max, setMax] = useState(props.max);
  const [min, setMin] = useState(props.min);
  const [fullMax] = useState(props.fullMax);

  return (
    <View style={{ alignSelf: "center", marginTop: 30, marginBottom: 30 }}>
      {props.max != undefined && props.min != undefined ? (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            minWidth: 300,
            maxWidth: "90%",
          }}>
          <TouchableOpacity
            onPress={async () => {
              if (used - 1 < min) return;
              const response = await makeRequest(
                "aforos/decrement/" + props.instalacion,
                "post"
              );
              if (used > 0 && response[0] == 200) setUsed(response[1].used);
            }}
            style={{
              height: 50,
              width: 50,
              backgroundColor: "white",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 30,
            }}>
            <Entypo name='minus' size={40} color='#3E4672' />
          </TouchableOpacity>

          <View style={{ margin: 10, flexDirection: "column" }}>
            <TouchableOpacity
              style={{ zIndex: 10 }}
              onPress={() => {
                props.setReload(!props.reload);
                console.log("recargando");
              }}>
              <Text
                style={{
                  fontFamily: "Montserrat-Bold",
                  color: "#3E4672",
                  fontSize: 20,
                  alignSelf: "center",
                }}>
                Aforo actual
              </Text>
              <Text
                style={{
                  fontFamily: "Montserrat-Regular",
                  color: "#3E4672",
                  fontSize: 20,
                  alignSelf: "center",
                }}>
                {used}/{max} ({fullMax})
              </Text>
            </TouchableOpacity>
          </View>
          <TouchableOpacity
            onPress={async () => {
              if (used + 1 > max) return;
              const response = await makeRequest(
                "aforos/increment/" + props.instalacion,
                "post"
              );
              if (response[0] == 200) setUsed(response[1].used);
            }}
            style={{
              height: 50,
              width: 50,
              backgroundColor: "white",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 30,
            }}>
            <Entypo name='plus' size={40} color='#3E4672' />
          </TouchableOpacity>
        </View>
      ) : (
        <TouchableOpacity
          style={{ zIndex: 10 }}
          onPress={() => {
            props.setReload(!props.reload);
            console.log("recargando");
          }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              minWidth: 300,
              maxWidth: "90%",
            }}>
            <View style={{ margin: 10, flexDirection: "column" }}>
              <Text
                style={{
                  fontFamily: "Montserrat-Bold",
                  color: "#3E4672",
                  fontSize: 20,
                  alignSelf: "center",
                }}>
                Aforo actual
              </Text>
              <Text
                style={{
                  fontFamily: "Montserrat-Regular",
                  color: "#3E4672",
                  fontSize: 20,
                  alignSelf: "center",
                }}>
                Cerrado
              </Text>
            </View>
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
}

function Cita(props) {
  return (
    <View
      style={{
        flex: 1,
        flexDirection: "row",
        minWidth: 300,
        backgroundColor: "rgba(255,255,255,0.9)",
        borderBottomColor: "#ccc",
        maxWidth: "100%",
        borderBottomWidth: 1,
        borderTopColor: "#ccc",
        borderTopWidth: 1,
      }}>
      <View
        style={{
          flexShrink: 0,
          justifyContent: "center",
          marginLeft: 5,
          flex: 1,
        }}>
        <Text
          style={{
            color: "#3E4672",
            fontFamily: "Montserrat-Bold",
            overflow: "hidden",
            marginBottom: 4,
          }}>
          {props.usuario}
        </Text>
        <Text style={{ fontFamily: "Montserrat-Regular", color: "#3E4672" }}>
          {props.fecha.getDate() >= 10
            ? props.fecha.getDate()
            : "0" + props.fecha.getDate()}
          /
          {props.fecha.getMonth() + 1 < 10
            ? "0" + (props.fecha.getMonth() + 1)
            : props.fecha.getMonth() + 1}
          /{props.fecha.getFullYear()}
        </Text>
        <Text style={{ fontFamily: "Montserrat-Regular", color: "#3E4672" }}>
          {props.fecha.getHours() < 10
            ? "0" + props.fecha.getHours()
            : props.fecha.getHours()}
          :
          {props.fecha.getMinutes() < 10
            ? "0" + props.fecha.getMinutes()
            : props.fecha.getMinutes()}{" "}
          -{" "}
          {props.final.getHours() < 10
            ? "0" + props.final.getHours()
            : props.final.getHours()}
          :
          {props.final.getMinutes() < 10
            ? "0" + props.final.getMinutes()
            : props.final.getMinutes()}
        </Text>
        <Text style={{ fontFamily: "Montserrat-Regular", color: "#3E4672" }}>
          {props.adultos +
            " " +
            (props.adultos == 1 ? "Adulto" : "Adultos") +
            " " +
            props.ninos +
            " " +
            (props.ninos == 1 ? "Niño" : "Niños")}
        </Text>
      </View>
      <View
        style={{
          flexDirection: "column",
          flex: 0,
        }}>
        <TouchableOpacity
          style={{
            justifyContent: "center",
            backgroundColor: "rgba(62, 70, 114, 0.4)",
            padding: 10,
            flexGrow: 1,
          }}
          onPress={() => {
            call({ number: props.telefono, prompt: true }).catch((e) =>
              console.log(e)
            );
          }}>
          <Text
            style={{
              fontFamily: "Montserrat-Regular",
              color: "white",
              textAlign: "center",
            }}>
            Llamar
          </Text>
        </TouchableOpacity>
        {!props.cancelada && (
          <TouchableOpacity
            style={{
              justifyContent: "center",
              backgroundColor: "'rgba(62, 70, 114, 0.5)",
              padding: 10,
            }}
            onPress={() =>
              makeRequest("citas/cancelar/" + props.id, "post").then(
                (response) => {
                  props.getCitas(props.fecha);
                }
              )
            }>
            <Text
              style={{
                fontFamily: "Montserrat-Regular",
                color: "white",
                textAlign: "center",
              }}>
              Cancelar
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}
